module.exports = __webpack_public_path__ + "img/stop_btn.8383f0ee.png";